@if (companyId) {
  <company-sites [companyId]="companyId" />
  <company-domains [companyId]="companyId" *requiredCredential="credentialTypeEnum.AccessCompanyDomains" />
}
